import { render, staticRenderFns } from "./ImportButton.vue?vue&type=template&id=5ce09d1a&scoped=true"
import script from "./ImportButton.vue?vue&type=script&lang=js"
export * from "./ImportButton.vue?vue&type=script&lang=js"
import style0 from "./ImportButton.vue?vue&type=style&index=0&id=5ce09d1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce09d1a",
  null
  
)

export default component.exports